<template>
  <!-- 公告详情 -->
  <div class="home">

    <HeaderReturn title="公告详情"></HeaderReturn>
    <!-- 公告 -->
    <div class="dataBox ">
      <!-- <div  style="margin-top: 10px;font-size: 18px;"> 各位伙伴:</div> -->




      <!-- <div class="title">{{details.title}}</div> -->
      <div style="margin-top: 10px;font-size: 18px;"> 
   
      <span v-html="details.content"></span>
      </div>

      <!-- <div class="fn-right" style="margin-top: 10px;font-size: 18px;">
        <p> 盖茨网关中国区推广社区宣</p>
        <p>{{  }}</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 公告
      title: this.$t('home.c4')
    };
  },
  created() {
    this.details = JSON.parse(this.$route.query.item)
    // this.getNoticeDetail();
  },
  methods: {
    goLink(path) {
      this.$router.push({
        path,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 引入全局的样式
@import "@/assets/scss/base.scss";

.home {
  padding: 0 15px;
  ::v-deep .van-nav-bar__title {
        color: #fff;
    }
  // 历史持仓
  .dataBox {
    // background: rgba(20, 132, 195, 0.2);
    /* 黄/主题 */

    border: 0.5px solid #f89b19;
    // box-shadow: 0px 0px 10px 4px rgba(20, 132, 195, 0.25), inset 0px 0px 10px -4px rgba(20, 132, 195, 0.25);
    border-radius: 4px;
    border-radius: 4px;
    padding: 10px;
    margin-top: 80px;
    color: #fff;

    .title {
      color: #ffc936;
      font-size: 18px;
      margin-bottom: 15px;
    }

    .username {
      margin-top: 50px;
    }
  }
}
</style>
